import apiRequest from './client';

export const listProducts = () => apiRequest('/products/');

// tirage '0' = parametre TOUS (general) ; effective=true (avec une loterie) =
// valeur REELLEMENT appliquee (propre, sinon heritee), une par produit.
export const listProductConfigs = ({ tirage, group, bank, supervisor, effective } = {}) => {
  const params = new URLSearchParams();
  if (tirage !== undefined && tirage !== null && tirage !== '') params.set('tirage', tirage);
  if (effective) params.set('effective', '1');
  if (group) params.set('group', group);
  else if (bank) params.set('bank', bank);
  else if (supervisor) params.set('supervisor', supervisor);
  return apiRequest(`/product-configs/?${params.toString()}`);
};

export const createProductConfig = (data) =>
  apiRequest('/product-configs/', { method: 'POST', body: data });

export const updateProductConfig = (id, data) =>
  apiRequest(`/product-configs/${id}/`, { method: 'PATCH', body: data });

export const deleteProductConfig = (id) =>
  apiRequest(`/product-configs/${id}/`, { method: 'DELETE' });
